import { FC } from 'react';

import { IconProps } from '.';

export const TimelineDotIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  color = '#F97316',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z"
      stroke={color}
    />
    <circle cx="12" cy="12" r="4" fill={color} />
  </svg>
);
